import { render, staticRenderFns } from "./LockAccountSwitch.vue?vue&type=template&id=22f16aba&"
import script from "./LockAccountSwitch.vue?vue&type=script&lang=js&"
export * from "./LockAccountSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LockAccountSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f16aba')) {
      api.createRecord('22f16aba', component.options)
    } else {
      api.reload('22f16aba', component.options)
    }
    module.hot.accept("./LockAccountSwitch.vue?vue&type=template&id=22f16aba&", function () {
      api.rerender('22f16aba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Account/LockAccountSwitch.vue"
export default component.exports